import React, { useState, useEffect } from "react";
import Sidebar from "./AdminSidebar"; // Adjust path as needed
import Navbar from "./Navbar"; // Adjust path as needed
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  // Set initial sidebar state based on screen size
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    window.innerWidth >= 768 // Default to open on desktop, closed on mobile
  );

  // Handle sidebar visibility based on screen size
  useEffect(() => {
    const handleResize = () => {
      // Close sidebar on mobile (< 768px) by default, open on desktop
      setIsSidebarOpen(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <div className="flex flex-1 w-full">
        {/* Sidebar */}
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        {/* Main content area */}
        <div
          className={`flex-1 p-2 transition-all overflow-hidden duration-300 ease-in-out 
          ${isSidebarOpen ? "md:ml-52 ml-0" : "ml-0"}`}
        >
          {/* Navbar */}
          <Navbar toggleSidebar={toggleSidebar} />
          {/* <br /> */}

          {/* Page content */}
          <div className="content flex-1 max-w-full min-h-screen">
            <Outlet />
          </div>

          {/* Responsive Footer */}
          <footer className="bg-gray-800 text-white text-center sm:text-right p-2 mt-4 shrink-0 w-full rounded-md">
            <p className="text-sm">
              Designed with ❤️ and crafted with care by Team{" "}
              <a
                href="https://www.youtube.com/@SHALENDERSINGH"
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-500 font-bold block sm:inline hover:text-yellow-600"
              >
                SMART ITBOX
              </a>
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;